module.exports = __webpack_public_path__ + "static/media/Fugaso.a5d01063.jpeg";